import Nullstack from 'nullstack';
export default function IconBrandMatrix({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-matrix",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 3h-1v18h1"
  }), "   ", Nullstack.element("path", {
    d: "M20 21h1v-18h-1"
  }), "   ", Nullstack.element("path", {
    d: "M7 9v6"
  }), "   ", Nullstack.element("path", {
    d: "M12 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
  }), "   ", Nullstack.element("path", {
    d: "M17 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
  }), " ");
}